import { Box, useTheme } from '@material-ui/core'
import { ORDER_FILTERS, ORDER_PROPS, ORDER_STATES } from 'shared'

export interface StatusLabelProps {
  type: 'state' | 'filter' | 'prop'
  name: string
  state: string
  active?: boolean
  clickable?: boolean
  numIssues?: number
  onClick?: (state: string) => void
}

const getBoxConfigs = (type: string) => {
  if (type === 'filter') {
    return ORDER_FILTERS
  } else if (type === 'prop') {
    return ORDER_PROPS
  } else {
    return ORDER_STATES
  }
}

export const StatusLabel = ({
  type,
  name,
  state,
  active,
  clickable,
  onClick,
  numIssues,
  ...props
}: StatusLabelProps): JSX.Element => {
  const { palette } = useTheme()
  const boxConfigs = getBoxConfigs(type)

  const { label, boxColor } = boxConfigs.find((s) => s.name === name) || {
    label: state,
    boxColor: palette.black,
    textColor: palette.black,
  }

  const style = {
    color: boxColor,
    borderRadius: '5px',
    width: '85px',
    marginLeft: '3px',
    marginRight: '3px',
    fontWeight: '700',
    cursor: clickable ? 'pointer' : '',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px',
  }

  const getLabel = () => {
    let outputLabel = label
    if (numIssues) {
      outputLabel = `${numIssues} ${label.toLocaleUpperCase()}`
      if (numIssues === 1) {
        outputLabel = outputLabel.substring(0, outputLabel.length - 1)
      }
    }
    return outputLabel
  }

  return (
    <>
      <Box
        onClick={() => {
          clickable && onClick ? onClick(state) : null
        }}
        textAlign="center"
        style={style}
        {...props}
      >
        <span>{getLabel()}</span>
      </Box>
    </>
  )
}
